/* eslint-disable */

// CHECKOUT
// class is used to handle the CHECKOUT page of course
// since it has been redesigned and stuff...
//
import $ from "jquery";

let checkout_info_tab, checkout_pay_tab, checkout_payment_wrapper, checkout_address_wrapper,
  wc_proceed_to_payment_button, wc_proceed_to_pay_button, customer_type_ouder, formFieldHeading, self;

export class WC_Checkout {

  constructor() {
    self = this;

    // is the Checkout element even here?
    if (!$('.woocommerce').length > 0) return;

    checkout_info_tab = $('.checkout_info_tab');
    checkout_pay_tab = $('.checkout_pay_tab');

    checkout_address_wrapper = $('.checkout_address_wrapper');
    checkout_payment_wrapper = $('.checkout_payment_wrapper');

    wc_proceed_to_payment_button = $('.payment_button');
    wc_proceed_to_pay_button = $('.pay_button');

    customer_type_ouder = $('#customer_type_ouder');

    formFieldHeading =  $('.student_info_exord h3').html();

    this.register_buttons();

    // On selecting a payment option
    checkout_payment_wrapper.on('click', '.wc_payment_method', function () {
      let selected_payment = $(this).children('input').val();
      // update the pay button label
      wc_proceed_to_pay_button.find('span').html(selected_payment);
    })

    // on changing customer type, show / hide on parent
    $('input:radio[name="customer_type"]').on('change',
      function () {
        if ($(this).is(':checked') && $(this).val() == 'ouder') {
          self.show_student_form('show');
        } else {
          self.show_student_form('hide');
        }
      });

    // add div to span elements
    $('#billing_address_1, #billing_city')
      .after("<div class='billing-js-address-spinner autofill__spinner'></div>");
    $('#shipping_address_1, #shipping_city')
      .after("<div class='shipping-js-address-spinner autofill__spinner'></div>");

    // No standard value for postcode and nr
    $('#billing_postcode, #billing_address_house_nr, #shipping_postcode, #shipping_address_house_nr')
      .attr('value', '');
    // Reset input value and add autocomplete=off to elements
    $('input#billing_address_1, input#billing_city, input#shipping_address_1, input#shipping_city')
      .attr('value', '')
      .attr('autocomplete', 'off')
      //.attr('readonly', true)
      //.addClass('no-outline')
    ;


    // on input of email fields, remove errors to be sure
    $('#student_email, #billing_email').on('input blur',
      function () {
        $('#student_email_field, #billing_email_field')
          .addClass('woocommerce-validated')
          .removeClass('woocommerce-invalid-required-field')
          .removeClass('woocommerce-invalid ')
          .find('.kg-invalid-msg')
          .remove();
      });

    // Call the populateCheckoutFields function when the page loads
    this.populateCheckoutFields();

    // Dynamically identify all form fields in the checkout
    const formFields = document.querySelectorAll('.woocommerce form input, .woocommerce form select');

    formFields.forEach(function (field) {

      if (field.type === 'checkbox') {
        field.addEventListener('change', function () {
          let fieldName = field.getAttribute('id');
          self.storeCheckoutData(fieldName, field.checked); // Pass the field name and its checked state
        });
      } else if (field.type === 'radio') {
        field.addEventListener('change', function () {

          // First remove all found GROUP elements based on the current name
          let groupName = field.getAttribute('name');
          let allRadios = document.querySelectorAll('input[name="' + groupName + '"]');
          allRadios.forEach(function (radio) {
            self.removeCheckoutData(radio.getAttribute('id'));
          });

          // Store the new radio value of this group
          let fieldName = field.getAttribute('id');
          self.storeCheckoutData(fieldName, field.checked);
        });
      } else {
        let fieldName = field.getAttribute('id');
        // jQuery used, since the caller of 'change' is coming from jQuery (WC_Checkout_Autofill.js)
        //
        $(field).on('change', function () {
          self.storeCheckoutData(fieldName, field.value); // Pass the field name and its valuez
        });
      }
    });
  }

  /**
   * Store given FieldNAme in the checkoutData object
   * with given value
   *
   * @param fieldName
   */
  storeCheckoutData(fieldName, value) {
    var formData = JSON.parse(sessionStorage.getItem('checkoutData')) || {};
    // For checkboxes, store the checked state directly instead of the value
    formData[fieldName] = typeof value === 'boolean' ? value : document.getElementById(fieldName).value;

    sessionStorage.setItem('checkoutData', JSON.stringify(formData));
  }

  /**
   * remove given FieldNAme from the checkoutData object
   *
   * @param fieldName
   */
  removeCheckoutData(fieldName) {
    var formData = JSON.parse(sessionStorage.getItem('checkoutData')) || {};

    if (fieldName in formData) {
      delete formData[fieldName];
    }
    sessionStorage.setItem('checkoutData', JSON.stringify(formData));
  }

  populateCheckoutFields() {
    var storedData = sessionStorage.getItem('checkoutData');
    const formFields = document.querySelectorAll('.woocommerce form input, .woocommerce form select');

    if (storedData) {
      var formData = JSON.parse(storedData);

      formFields.forEach(function (field) {
        let fieldName = field.getAttribute('id');
        if (field.type === 'checkbox') {
          // Check if the checkbox state is stored in the session data
          if (formData[fieldName]) {
            field.checked = formData[fieldName];
          }
        } else if (field.type === 'radio') {
          // Check if the radio state is stored in the session data
          if (formData[fieldName]) {
            field.checked = formData[fieldName];
          }
        } else {
          // For other types of fields, populate their values
          if (formData[fieldName]) {
            field.value = formData[fieldName];
          }
        }
        $(field).trigger('change');
      });
    }
  }

  show_student_form($show) {

    if ($show === 'show') {

      $('.student_info').show();

      $('.student_info_exord h3').text(self.formFieldHeading);

      const studentPhone = document.getElementById("student_phone_field");
      studentPhone.classList.add("validate-required");
      studentPhone.classList.add("validate-phone");
      const studentEmail = document.getElementById("student_email_field");
      studentEmail.classList.add("validate-required");
      studentEmail.classList.add("validate-email");
      const studentName = document.getElementById("student_first_name_field");
      const studentLastName = document.getElementById("student_last_name_field");
      studentName.classList.add("validate-required");
      studentLastName.classList.add("validate-required");

    } else {

      $('.student_info').hide();
      $('.student_info_exord h3').text("Persoonsgegevens");

      const studentEmail = document.getElementById("student_email_field");
      studentEmail.classList.remove("validate-required");
      studentEmail.classList.remove("validate-email");
      const studentPhone = document.getElementById("student_phone_field");
      studentPhone.classList.remove("validate-required");
      studentPhone.classList.remove("validate-phone");
      const studentName = document.getElementById("student_first_name_field");
      const studentLastName = document.getElementById("student_last_name_field");
      studentName.classList.remove("validate-required");
      studentLastName.classList.remove("validate-required");
    }

  }
  /**
   * Hook all buttons to click events
   */
  register_buttons() {

    // go to payment section,
    wc_proceed_to_payment_button.on('click', function (e) {
      e.preventDefault();
      self.validate_all_fields();
    });

    // go (back) to info section
    $('.back_to_checkout_info').on('click', function (e) {
      e.preventDefault();
      self.show_info_tab()
    })
    checkout_info_tab.on('click', function (e) {
      e.preventDefault();
      self.show_info_tab()
    })

    // go to the pay section (outside WC)
    wc_proceed_to_pay_button.on('click', function (e) {
      e.preventDefault();
    });

    // dead link
    checkout_pay_tab.on('click', function (e) {
      e.preventDefault();
    });

  }

  validate_all_fields() {
    let any_invalid = false;
    let invalids_array = [];
    let ship_to_diff = $('#ship-to-different-address input').is(':checked');

    $('.kg-invalid-msg').fadeOut(500, function () {
      $(this).remove();
    });

    $('.woocommerce-invalid').removeClass('woocommerce-invalid woocommerce-invalid-required-field');

    $('.validate-required').each(function (i) {

      let $this = $(this).find('input[type=checkbox],select,.input-text'),
        $parent = $this.closest('.form-row'),
        validated = true,
        validate_required = $parent.is('.validate-required'),
        validate_email = $parent.is('.validate-email'),
        validate_phone = $parent.is('.validate-phone'),
        validate_middle_name = $parent.is('.validate-middle-name'),
        validate_house_nr_add = $parent.is('.validate-house-nr-add'),
        validate_postal_code = $parent.is('.validate-postcode');

      if (!ship_to_diff && $this.parents('.woocommerce-shipping-fields').length) {
        return true;
      }

      if (validate_required) {
        if ('checkbox' === $this.attr('type') && !$this.is(':checked')) {
          $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
          validated = false;
          any_invalid = true;
        } else if ($this.val() === '') {
          $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
          validated = false;
          any_invalid = true;
        }
      }

      // Allow special characters in name fields
      const name_fields = ['billing_first_name', 'billing_last_name', 'shipping_first_name', 'shipping_last_name', 'student_first_name', 'student_last_name'];
      if ($.inArray($this.attr('id'), name_fields) >= 0) {
        if ($this.val()) {
          let pattern = new RegExp(/^[A-zÀ-ÿ -]*$/)

          if (!pattern.test($this.val())) {
            $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-text');
            validated = false;
            any_invalid = true;
          }
        }
      }

      // Define a minimum of 2 characters
      const characters_fields = ['billing_last_name', 'shipping_last_name', 'student_last_name','billing_address_1', 'billing_city', 'shipping_address_1', 'shipping_city'];
      if ($.inArray($this.attr('id'), characters_fields) >= 0) {
        if ($this.val().length < 2) {
          $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-text');
          validated = false;
          any_invalid = true;
        }
      }

      // Check if text fields has only text
      const text_fields = ['billing_address_1', 'billing_city', 'shipping_address_1', 'shipping_city'];
      if ($.inArray($this.attr('id'), text_fields) >= 0) {
        if ($this.val()) {
          let pattern = new RegExp(/^[^{}<>]+$/)

          if (!pattern.test($this.val())) {
            $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-text');
            validated = false;
            any_invalid = true;
          }
        }
      }

      if (validate_postal_code) {
        if ($this.val()) {

          let pattern = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;

          if (!pattern.test($this.val())) {
            $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-text');
            validated = false;
            any_invalid = true;
          }
        }
      }

      if (validate_email) {
        if ($this.val()) {

          let pattern = new RegExp(/^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i);

          if (!pattern.test($this.val())) {
            $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-email');
            validated = false;
            any_invalid = true;
          }
        }
      }
      if (validate_phone) {
        if ($this.val()) {
          let phone_value = $this.val();
          let pattern = /^\+([0-9]{11})$/;
          if (pattern.test($this.val())) {
            $parent.addClass('woocommerce-validated').removeClass('woocommerce-invalid woocommerce-invalid-phone');
            validated = true;
            any_invalid = false;
          } else if (phone_value.length !== 10 && phone_value.length !== 13) {
            $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-phone');
            validated = false;
            any_invalid = true;
          }
        }
      }

      if (validate_middle_name) {
        if ($this.val()) {
          let pattern = new RegExp(/^[a-z-A-Z -]*$/)

          if (!pattern.test($this.val())) {
            $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-text');
            validated = false;
            any_invalid = true;
          }
        } else {
          $parent.addClass('woocommerce-validated').removeClass('woocommerce-invalid woocommerce-invalid-text');
          validated = true;
          any_invalid = false;
        }
      }

      if (validate_house_nr_add) {
        if ($this.val()) {
          let pattern = new RegExp(/^[^{}<>]+$/);

          if (!pattern.test($this.val())) {
            $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-text');
            validated = false;
            any_invalid = true;
          }
        } else {
          $parent.addClass('woocommerce-validated').removeClass('woocommerce-invalid woocommerce-invalid-text');
          validated = true;
          any_invalid = false;
        }
      }

      if (validated) {
        $parent.removeClass('woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email').addClass('woocommerce-validated');
      }

      invalids_array[i] = any_invalid;

    });

    // if equal emails, fail
    if ($('#customer_type_ouder').is(':checked')) {
      if ($('#student_email').val() === $('#billing_email').val()) {
        $('#student_email_field, #billing_email_field')
          .removeClass('woocommerce-validated')
          .addClass('woocommerce-invalid-required-field')
          .addClass('woocommerce-invalid ')
          .append('<div class="kg-invalid-msg">Leerling e-mail kan niet gelijk zijn aan ouder e-mail.</div>');
        any_invalid = true;
      }}

    let has_invalid = false;
    for (let i = 0; i < invalids_array.length; ++i) {
      if (invalids_array[i]) {
        has_invalid = true;
      }
    }

    if (has_invalid) {

      // Scroll to first invalid input
      let $first_invalid = $('.woocommerce-invalid:first');
      let $all_invalid = $('.woocommerce-invalid');

      let $msg = $('<div class="kg-invalid-msg">Ongeldige waarde</div>').appendTo($all_invalid);
      $('html,body').animate({
        scrollTop: $first_invalid.offset().top - 70
      }, 1000);

      $all_invalid.find('input,select').on('input change', function () {
        $msg.fadeOut(500, function () {
          $msg.remove();
        });
      });

      $('.woocommerce-invalid').find('input,select').on('input change', function () {
        $(this).closest('.form-row').removeClass('woocommerce-invalid woocommerce-invalid-required-field');
      });

    } else {

      self.sync_addresses();
      self.show_payment_tab();

    }
  }

  // since the design has double location for address
  // sync the input tab with the presentation tab
  sync_addresses() {

    $('.payment_billing_address_name').html($('#billing_first_name').val() + ' ' + $('#billing_last_name').val());
    $('.payment_billing_phone').html($('#billing_phone').val());
    $('.payment_billing_email').html($('#billing_email').val());
    $('.payment_billing_address').html($('#billing_address_1').val() + ' ' + $('#billing_address_house_nr').val() + ' ' + $('#billing_address_house_nr_add').val());
    $('.payment_billing_address_2').html($('#billing_postcode').val() + ' ' + $('#billing_city').val());

    let ship_to_diff = $('#ship-to-different-address input').is(':checked');
    if (!ship_to_diff) {

      // shipping is same as billing
      $('.payment_shipping_address_name').html($('#billing_first_name').val() + ' ' + $('#billing_last_name').val());
      $('.payment_shipping_phone').html($('#billing_phone').val());
      $('.payment_shipping_email').html($('#billing_email').val());
      $('.payment_shipping_address').html($('#billing_address_1').val() + ' ' + $('#billing_address_house_nr').val() + ' ' + $('#billing_address_house_nr_add').val());
      $('.payment_shipping_address_2').html($('#billing_postcode').val() + ' ' + $('#billing_city').val());

    } else {

      // shipping is different from billing
      $('.payment_shipping_address_name').html($('#shipping_first_name').val() + ' ' + $('#shipping_last_name').val());
      $('.payment_shipping_phone').html($('#shipping_phone').val());
      $('.payment_shipping_email').html($('#shipping_email').val());
      $('.payment_shipping_address').html($('#shipping_address_1').val() + ' ' + $('#shipping_address_house_nr').val() + ' ' + $('#shipping_address_house_nr_add').val());
      $('.payment_shipping_address_2').html($('#shipping_postcode').val() + ' ' + $('#shipping_city').val());

    }
  }

  /**
   * Switch to the INFO tab
   * (+ show proper button and tab name)
   */
  show_info_tab() {

    checkout_info_tab.addClass('active');
    checkout_pay_tab.removeClass('active');

    checkout_address_wrapper.removeClass('hide');
    checkout_payment_wrapper.addClass('hide');

    $('.wc_proceed_to_payment').removeClass('hide');
    $('.wc_proceed_to_pay').addClass('hide');

  }

  /**
   * Switch to the PAYMENT tab
   * (+ show proper button and tab name)
   */
  show_payment_tab() {

    checkout_info_tab.removeClass('active');
    checkout_pay_tab.addClass('active');

    checkout_address_wrapper.addClass('hide');
    checkout_payment_wrapper.removeClass('hide');

    $('.wc_proceed_to_payment').addClass('hide');
    $('.wc_proceed_to_pay').removeClass('hide');

  }


  is_valid($value, $type) {

    if (!$value) {
      return false;
    }

    if ($type === 'text') {
      // no numbers
    }
    if ($type === 'telephone') {
      // no alphanumeric
    }
    if ($type === 'email') {
      //
    }
    if ($type === 'postcode') {
      // trim
    }

    return false;
  }
}
